import * as React from "react";
import { forwardRef } from "react";
const SvgCloseXlg = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "m9.051 7.966 4.98-5.008a.8.8 0 0 0-.257-1.297.79.79 0 0 0-.863.173L7.931 6.84l-4.98-5.007a.79.79 0 0 0-1.12 0 .8.8 0 0 0 0 1.124l4.98 5.008-4.98 5.007a.8.8 0 0 0 .257 1.297.79.79 0 0 0 .863-.172l4.98-5.008 4.98 5.008a.789.789 0 0 0 1.351-.563.8.8 0 0 0-.23-.562z" }));
const ForwardRef = forwardRef(SvgCloseXlg);
export { ForwardRef as ReactComponent };
